export type TonyteConfirmationRequest = {
  title: string;
  message: string;
  cancelLabel: string;
  confirmLabel: string;
  icon?: string;
  resolve: (confirmed: boolean) => void;
};

type ConfirmationListener = (request: TonyteConfirmationRequest) => void;

let listener: ConfirmationListener | null = null;
let pendingResolve: ((confirmed: boolean) => void) | null = null;

export function subscribeTonyteConfirmation(nextListener: ConfirmationListener): () => void {
  listener = nextListener;
  return () => {
    if (listener === nextListener) listener = null;
  };
}

export function showTonyteConfirmation(
  request: Omit<TonyteConfirmationRequest, 'resolve'>,
): Promise<boolean> {
  if (!listener) return Promise.resolve(false);

  pendingResolve?.(false);
  return new Promise(resolve => {
    let settled = false;
    const settle = (confirmed: boolean) => {
      if (settled) return;
      settled = true;
      if (pendingResolve === settle) pendingResolve = null;
      resolve(confirmed);
    };
    pendingResolve = settle;
    listener?.({ ...request, resolve: settle });
  });
}
